import { LoginType } from '@panda/cache/src/user/define';
import { gaUtil, mobileUtil, saveAuth } from '@panda/tool';
import UserCache from '@panda/cache/src/user/cache';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import loadingDirective from './directive/loading';
import './plugins/cache';
import './plugins/vant';
import '@/common/style/style.scss';
import '@/style/style.scss';
import { logout } from './util/login';

// 保存ledu auth
saveAuth();

const userCache = new UserCache();

Vue.config.productionTip = false;

Vue.directive('loading', loadingDirective);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// 天马增加公参
userCache.getUserInfoPure({})
  .then((res) => {
    // 微信环境（非小程序） 使用微信授权登录，退出重登
    if (res.userAccount.loginType === LoginType.Wechat && mobileUtil.isWeixin() && !mobileUtil.isMiniprogram()) {
      logout();
      return;
    }
    gaUtil.rAddPost('userid', `${res.userInfo.uid}`);
    gaUtil.rAddPost('is_vip', `${res.userInfo.isVip ? '是' : '否'}`);
  }).finally(() => {
    gaUtil.rSetReady(); // 设置ready之后，才会发送埋点
  });
